/**
 * ★ **홈이 서는 조건** (v32 · `docs/63` §3.1 · 절대 규칙 81).
 *
 * ── 홈은 URL 이 아니라 자리다 ───────────────────────────────
 *
 * 시작 게이트(`StartGate`)는 세 조건이 다 맞을 때만 섰다(`showsStartGate`) — 아직 안 틀었고 ·
 * 이 문서에서 소리 있는 재생 허가가 없고 · 자동 시작 경로가 아니다. **홈은 그 조건, 그 자리에
 * 선다.** 조건을 URL(`/home` · `?home=` · `?channel=` 로 건너뛰기)로 바꾸면 복귀 경로 셋
 * (상품 화면의 「방송 보기」 · 완료 화면 · 로그인)이 `navigate('/')` 라 홈에 떨어지고, 설치된
 * 앱의 매니페스트 `start_url` 도 `/` 라 같은 일이 난다 — 초안이 정확히 그렇게 틀렸다
 * (`docs/63` §0.2 ②).
 *
 * ── 순서가 계약이다 ─────────────────────────────────────────
 *
 * 1. `homeRequested` — 시청 중 「홈」 버튼. 무엇보다 세다(사람이 눌렀다).
 * 2. `debug` — `?debug=1` 은 하네스다. 옛 게이트를 본다 — `T_freeze` 둘에 프리뷰 비용이
 *    섞이면 **수치가 낮아진 것이 아니라 잰 것이 달라진 것**인데 보고서에 안 보인다.
 * 3. `unlocked` — 이 문서에 이미 허가가 있다(`buffersUnlocked()` · 모듈 스코프라 재마운트를
 *    건넌다). 채널 전환 · 「방송 보기」 · 편성표 카드가 전부 이 줄로 홈을 건너뛴다.
 * 4. 설치된 앱의 자동 시작(규칙 72) — Q1 이 **참**으로 답했다(2026-09-10). 게이트는 정책 때문에
 *    있었고 홈은 제품 때문에 있다. 상수 하나로 갈리고 `auto-start.ts` 는 열지 않는다.
 *
 * **순수 함수다** — 이 패키지는 node 환경에서 테스트한다(jsdom 미도입). `buffersUnlocked()`·
 * `config.debug`·`decideAutoStart()` 를 여기서 읽으면 이 판정이 검사에서 통째로 빠진다
 * (`channel-selection.ts` 와 같은 이유).
 */
export type EntrySurface = 'home' | 'play';

/** Q1 — 설치된 앱(노트북 PWA · Android PWA)도 첫 진입에 홈을 보는가. **참** (2026-09-10) */
export const HOME_FOR_INSTALLED = true;

export interface EntrySurfaceInput {
  /** `?debug=1` — 하네스. 옛 게이트를 본다 */
  readonly debug: boolean;
  /** `buffersUnlocked()` — 이 문서에서 소리 있는 재생 허가가 이미 있다 */
  readonly unlocked: boolean;
  /** `decideAutoStart()` — 설치된 앱 ∧ WebKit 아님 (절대 규칙 72) */
  readonly installedAutoStart: boolean;
  /** 시청 화면의 「홈」 버튼을 눌렀다 (`docs/63` §3.3 ⑥) */
  readonly homeRequested: boolean;
  /** Q1 의 답. `HOME_FOR_INSTALLED` — 인자로 받는 것은 테스트가 두 답을 다 재기 위해서다 */
  readonly homeForInstalled: boolean;
}

export function entrySurface(input: EntrySurfaceInput): EntrySurface {
  if (input.homeRequested) return 'home';
  if (input.debug) return 'play';
  if (input.unlocked) return 'play';
  if (input.installedAutoStart && !input.homeForInstalled) return 'play';
  return 'home';
}
